import React, { useEffect } from "react";

import { Pagination } from "../../../components/ui/Pagination";
import { Table } from "../../../components/ui/Table";

import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import { getCrmPetViewConfig } from "../constants";
import { WhatsAppModal } from "../Modals/WhatsAppModal";
import { TableViewport } from "../styles";
import { PetRow } from "./PetRow";

export function CrmPetTable() {
  const CCrmPet = CrmPetController();
  const config = useCrmPet((st) => st.data.config);
  const isWaiting = useCrmPet((st) => st.data.isWaiting);
  const pagination = useCrmPet((st) => st.data.pagination);
  const customers = useCrmPet((st) => st.data.customers);
  const sort = useCrmPet((st) => st.data.sort);
  const selectedCustomerKey = useCrmPet((st) => st.data.selectedCustomerKey);
  const whatsapp = useCrmPet((st) => st.data.whatsapp);
  const activeRule = useCrmPet((st) => st.data.filter.rule);

  const pageRows = customers[pagination.page] || [];
  // useEffect(() => {
  //   const refresh = () => { if (document.visibilityState !== "hidden") CCrmPet.refreshPets(); };
  //   document.addEventListener("visibilitychange", refresh);
  //   const expires = pageRows.flatMap((row) => row.memberships)
  //     .map((membership) => new Date(membership.contactExpiresAt || 0).getTime()).filter((time) => time > 0);
  //   const timer = expires.length ? window.setTimeout(refresh, Math.max(100, Math.min(...expires) - Date.now() + 100)) : null;
  //   return () => {
  //     document.removeEventListener("visibilitychange", refresh);
  //     if (timer) window.clearTimeout(timer);
  //   };
  // }, [CCrmPet, customers, pagination.page]);
  const viewConfig = getCrmPetViewConfig(activeRule);
  const columns = viewConfig.columns.map((column) => `${column.label}:${column.size}`);
  const sortableColumnKeys = viewConfig.columns.reduce((result, column) => {
    if (column.sortKey) result[column.label] = column.sortKey;
    return result;
  }, {});

  return (
    <>
      <div
        aria-labelledby={`crm-pet-tab-${activeRule.toLowerCase()}`}
        id="crm-pet-table-panel"
        role="tabpanel"
      >
        <TableViewport $minWidth={viewConfig.minWidth}>
          <Table.Root
            key={activeRule}
            name={`${CCrmPet.tableName}-${activeRule.toLowerCase()}`}
          >
            <Table.Header
              columns={columns}
              sortableConfig={{
                sortBy: sort.sortBy,
                sortOrder: sort.sortOrder,
                onSort: CCrmPet.handleSortColumn,
                columnKeys: sortableColumnKeys,
              }}
            />
            <Table.Content isLoading={isWaiting} loadingLine={10}>
              {pagination.totalDocuments === 0 && !isWaiting ? (
                <div style={{ textAlign: "center", padding: "60px 0", color: "#aaa", fontSize: 14 }}>
                  Nenhum pet encontrado para os filtros selecionados.
                </div>
              ) : (
                pageRows.map((row) => (
                  <PetRow
                    key={row.rowKey}
                    columns={viewConfig.columns}
                    row={row}
                  />
                ))
              )}
            </Table.Content>
          </Table.Root>
        </TableViewport>

        <Pagination.Root
          name={`${CCrmPet.paginationName}-${activeRule.toLowerCase()}`}
          totalPages={Math.max(0, pagination.totalPages - 1)}
          currentPage={pagination.page}
          onChange={(page) => CCrmPet.setPage(page)}
        >
          <Pagination.Back />
          <Pagination.Pages />
          <Pagination.Forward />
        </Pagination.Root>
      </div>

      {
        selectedCustomerKey && (
          <WhatsAppModal
            activeRule={activeRule}
            customer={whatsapp.customer}
            loading={whatsapp.loading}
            error={whatsapp.error}
            config={config}
            onClose={CCrmPet.closeWhatsApp}
          />
        )
      }
    </>
  );
}
